import { useMergingState } from '@/hooks';
import { WorkHistoryLayerActions, WorkHistoryLayerSelectors } from '@/stores';
import { MouseEventHandler, SyntheticEvent, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ResizeCallbackData } from 'react-resizable';

import {
	getColumns,
	HEADER_HEIGHT,
	TH_HEIGHT,
	TR_HEIGHT,
} from './work-history-layer.config';
import { TWorkHistoryLayerProps } from './work-history-layer.type';

const useLogic = (props: TWorkHistoryLayerProps) => {
	const columns = useMemo(() => getColumns(), []);
	const dispatch = useDispatch();

	const [state, setSate] = useMergingState({
		visible: false,
		width: 700,
		height: 260,
	});

	const workHistoryList = useSelector(WorkHistoryLayerSelectors.selectList);

	const loading = useSelector(WorkHistoryLayerSelectors.selectFetching);

	const handleClosePopover = useCallback(() => {
		setSate({
			visible: false,
		});
	}, []);

	const handleOpenPopover = useCallback(
		async (open: boolean) => {
			if (open) {
				setSate({
					visible: open,
				});

				dispatch(
					WorkHistoryLayerActions.getWorkHistoryLayerListRequest({
						applicantId: props?.id,
					})
				);
			} else {
				setSate({
					visible: open,
				});
			}
		},
		[props?.id]
	);

	const onClick: MouseEventHandler<HTMLDivElement> = useCallback((e) => {
		e.stopPropagation();
	}, []);

	const handleResize = useCallback(
		(e?: SyntheticEvent<Element, Event>, data?: ResizeCallbackData) => {
			if (!data?.size) return;
			setSate({
				width: data?.size?.width,
				height: data?.size?.height,
			});
		},
		[]
	);

	const scrollHeight = useMemo(() => {
		if (workHistoryList.length <= 3) return undefined;
		if (
			workHistoryList.length * TR_HEIGHT <
			state.height - HEADER_HEIGHT - TH_HEIGHT
		)
			return undefined;

		return state.height - HEADER_HEIGHT - TH_HEIGHT;
	}, [workHistoryList, state.height]);

	return {
		state,
		columns,
		handleClosePopover,
		handleOpenPopover,
		onClick,
		handleResize,
		scrollHeight,
		workHistoryList,
		loading,
	};
};

export default useLogic;
